import { Typography } from "antd";

const { Text } = Typography;

export interface WidgetInfoRow {
  queryId: string;
  label: string;
  aggLabel: string;
  dates: string;
  subjects: string;
  groupBy?: string;
  scale?: string;
  extras?: string[];
}

export function WidgetInfoPopoverContent({ rows }: { rows: WidgetInfoRow[] }) {
  return (
    <div style={{ maxWidth: 360, fontSize: 12, lineHeight: 1.6 }}>
      {rows.map((row) => (
        <div key={row.queryId} style={{ marginBottom: 8 }}>
          <Text strong style={{ fontSize: 12 }}>{row.label}</Text>
          <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)" }}>
            <div>Aggregate: {row.aggLabel}</div>
            <div>Dates: {row.dates}</div>
            <div>Players: {row.subjects}</div>
            {row.scale && <div>Scale: {row.scale}</div>}
            {row.groupBy && <div>Grouped By: {row.groupBy}</div>}
            {row.extras && row.extras.length > 0 && <div>Additional: {row.extras.join(", ")}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
